import React from 'react';
import styles from './BasicItemListView.module.scss';
import { IconButton } from 'components/common';
import { icons } from 'assets';
import { TimeIntervalsInfoBlob } from 'components/editor';
import { BasicItemListViewProps } from './types';

const BasicItemListView = (props: BasicItemListViewProps) => {
  const {
    onContainerLoad = null,
    name,
    pictureComponent,
    shotsCount,
    entityId = null,
    entityClass = null,
    timeIntervals = null,
    children = null
  } = props;
  const [showInfo, setShowInfoFlag] = React.useState(false);

  return (
    <div className={styles.container} onLoad={onContainerLoad}>
      {pictureComponent}
      <div className={styles.nameContainer}>
        <div>{name}</div>
        <div>USED IN {shotsCount} SHOTS</div>
      </div>
      {!!shotsCount &&
        <div
          className={styles.iconsContainer}
        >

          <IconButton
            icon={icons.checked}
            className={styles.usedIcon}
            title='This item is in use'
          />
          <IconButton
            icon={icons.info}
            onClick={() => setShowInfoFlag(!showInfo)}
          />

          {showInfo &&
            <TimeIntervalsInfoBlob
              hide={() => setShowInfoFlag(false)}
              entityId={entityId}
              entityClass={entityClass}
              timeIntervals={timeIntervals}
            />
          }
        </div>
      }
      {children}
    </div>
  );
};

export default BasicItemListView;
